


import BaseComponent from '@/components/base-component.vue';
import { decimalFormat } from '@/helpers/decimalFormat';
import { sortKey } from '@/helpers/sort';
import { toNumber } from '@/helpers/toNumber';
import { PrescricaoParmDTO } from '@/interfaces/prescription';
import { TemplateValidacaoParmDTO } from '@/interfaces/prescription-template';
import PrescriptionBaseModel from '@/models/prescription-base-model';
import PrescriptionModel from '@/models/prescription-model';
import PrescriptionTemplateModel from '@/models/prescription-template-model';
import * as service from '@/services/prescription';
import { validatePrescriptionTemplate } from '@/services/prescription-templates';
import { PARAM_GLICOSE_GROUP } from '@/settings/consts/prescription-params';
import { PrescriptionValidation } from '@/settings/consts/prescription-validation';
import { cloneDeep } from 'lodash';
import { BehaviorSubject, Observable, of, timer } from 'rxjs';
import {
  catchError, debounce, skipWhile, switchMap, tap
} from 'rxjs/operators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';





@Component
export default class PrescriptionBase extends BaseComponent {

  @Prop({default: false})
  public alter: boolean;

  @Prop({default: () => []})
  public idsAlter: number[];
  
  public form: any = {
    valid: false,
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: PrescriptionBaseModel = null;

  public groupList: any[] = [];
  public receivedProducts: any[] = [];
  public receivedWeight: any = null;
  public receivedCaloricWeight: any = null;
  public receivedInfusionTime: any = null;
  public prescricaoResumo: any = {};
  public validationMessages: any[] = [];
  public validationMessagesLoading: boolean = false;
  public validationMessagesError: boolean = false;
  public validationMessagesFirstTime: boolean = true;
  public prescriptionState: any = PrescriptionValidation.INVALID.key;

  public products: any[] = [];
  public resumeProducts: any = [];

  public lockFields: boolean = false;

  private validate$: BehaviorSubject<any> = new BehaviorSubject('initialize');
  private oldPrescriptionState = null;
  private productsToCorrect: any[] = [];
  private productToCorrect: any = null;

  public idsProdWaiting: Number[] = [];
  uuid = null;

  @Watch('item.paciente')
  public onPatientChange(): void {
    this.idsProdWaiting = [];
    this.item.produtos = [];
    if (!(this.item instanceof PrescriptionTemplateModel) && !this.item.isVisualization()) {
      this.item.volumeDesejado = null;
    }
  }

  @Watch('item.produtos')
  public onProductsChange(): void {
    this.item.calcTypedVolume();
  }

  @Watch('form.valid')
  public onFormValidChange(): void {
    this.validate();
  }

  @Watch('item.tipoPaciente')
  public onChangePatientType(): void {
    this.item.produtos = [];
    this.idsProdWaiting = [];
    this.receivedProducts = [];
    this.receivedWeight = null;
    this.receivedCaloricWeight = null;
    this.receivedInfusionTime = null;
    this.resumeProducts = [];
    this.validationMessagesFirstTime = true;
    this.validationMessagesError = false;
    this.setPrescriptionState(PrescriptionValidation.INVALID.key);
    this.resumeGenerator();
    this.validate();
  }

  public beforeMount(): void {
    this.subscribeValidate();
  }

  public resetPrescription(): void {
    this.lockFields = false;
    this.products = [];
    this.receivedProducts = [];
    this.receivedWeight = null;
    this.receivedCaloricWeight = null;
    this.receivedInfusionTime = null;
    this.resumeProducts = [];
    this.item.produtos = [];
    this.idsProdWaiting = [];
    this.groupList = [];
    this.validationMessagesFirstTime = true;
    this.validationMessagesError = false;
    this.setPrescriptionState(PrescriptionValidation.INVALID.key);
    this.$refs.form.resetValidation();
    this.uuid = (window.crypto as any).randomUUID();    
  }

  public onChangeSchedulingDate(val): void {
    this.resumeGenerator();
    this.validate();
  }

  public onChangeWeight(): void {
    this.resumeGenerator();
    this.validate();
  }

  private onCaloricWeightChange(val: boolean) {
    this.item.usoPesoCalorico = val;    
  }

  public onChangeDoctor(): void {
    this.resumeGenerator();
    this.validate();
  }

  public onChangeMLDia(): void {
    this.resumeGenerator();
    this.validate();
  }

  public onChangePatient(): void {
    this.prescricaoResumo = {};
    this.validationMessages = [];
  }

  public onChangeTerapia(): void {
    this.resumeGenerator();
    this.validate();
  }

  public onChangeViaAdministracao(): void {
    this.resumeGenerator();
    this.validate();
  }

  public onChangeDivisaoBolsa(): void {
    this.resumeGenerator();
    this.validate();
  }

  public onChangeTempoInfusao(): void {
    this.resumeGenerator();
    this.validate();
  }

  public onClickShowErrorProducts(val): void {
    this.productsToCorrect = cloneDeep(val);
  }

  public onClickFocusErrorProduct(val): void {
    this.productToCorrect = cloneDeep(val);
  }

  public onUnitsCalculate(unit, product): void {
    this.addProductToResume(unit, product);
    this.resumeGenerator();
    this.item.setProducts(this.flatProducts(this.groupList));
    this.validate();
  }

  public onFocusInputUnit(): void {
    this.setPrescriptionState(PrescriptionValidation.TYPING.key);
  }

  public onChangeInputUnit(): void {
    this.setPrescriptionState(PrescriptionValidation.INVALID.key);
  }

  public onBlurInputUnit(): void {
    if (
      this.oldPrescriptionState !== PrescriptionValidation.LOADING.key &&
      this.oldPrescriptionState !== PrescriptionValidation.TYPING.key &&
      this.oldPrescriptionState !== PrescriptionValidation.INVALID.key &&
      !!this.oldPrescriptionState
    ) {
      this.setPrescriptionState(this.oldPrescriptionState);
    }
  }

  protected flatProducts(groups: any[], forceGlicose?: boolean): any[] {
    if (!groups.length) {
      return [];
    }
    return groups.reduce((acc, cur) => {
      const result = cur.subgrupos.reduce((accSub, curSub) => {
        const prod = curSub.produtos
          .map((product) => {
            const units = product.unidadeMedidasProduto.filter(
              (v) => toNumber(v.valor) > 0,
            );

            // TODO: change the condition (subgroup.nome.toLowerCase() === PARAM_GLICOSE_GROUP) to parameter received from API after parameters screen is done
            if (
              forceGlicose &&
              !!product.subgroup &&
              product.subgrupo.id === PARAM_GLICOSE_GROUP &&
              !units.length
            ) {
              units.push(product.unidadeMedidasProduto[0]);
            }
            return {
              ...product,
              idProduto: product.id,
              unidadeMedidasProduto: units,
              unidades: units,
            };
          })
          .filter((p) => !!p.unidadeMedidasProduto.length);

        accSub.push(...prod);
        return accSub;
      }, []);
      acc.push(...result);
      return acc;
    }, []);
  }

  private calcTypedVolume(): void {
    if (!this.item.produtos.length) {
      this.item.volumeDigitado = '0';
    }
    const currentTotalVolume = this.item.produtos.reduce((total, product) => {
      const unitFound = product.unidadeMedidasProduto.find((unit) => {
        return unit.id === 1;
      });

      if (!!unitFound) {
        let sum = total + toNumber(unitFound.valor);
        sum = decimalFormat(sum);
        sum = toNumber(sum, true);
        return sum;
      } else {
        return total;
      }
    }, 0);

    this.item.volumeDigitado = currentTotalVolume;
  }

  private resumeGenerator() {
    if (
      !this.item.paciente ||
      !this.item.paciente.peso ||
      !this.item.produtos.length ||
      !this.isProdutosProntos()
    ) {
      return;
    }
    this.resumeProducts = this.item.produtos;
  }

  private addProductToResume(unit: any, product: any): void {
    const value = unit.valor;
    const index = this.products.findIndex((item) => item.id === product.id);
    const minValueOfProduct = 0;

    if (index !== -1) {
      this.products.splice(index, 1);
    }

    if (value > minValueOfProduct) {
      this.products.push({
        id: product.id,
        descricao: product.descricao,
        ordem: product.ordem,
        unidade: {
          ...unit,
          valor: decimalFormat(unit.valor),
        },
      });
    }

    this.products = this.products.sort(sortKey('ordem'));
  }

  private validate() {
    this.$refs.form.validate();

    this.validationMessages = [];
    this.productsToCorrect = [];
    this.productToCorrect = null;
    this.validationMessagesLoading = true;

    this.setPrescriptionState(PrescriptionValidation.LOADING.key);
    if (
      !this.form.valid ||
      !toNumber(this.item.volumeDesejado) ||      
      !this.item.valid() ||
      !this.flatProducts(this.groupList).length
    ) {
      this.validationMessagesLoading = false;
      this.validationMessagesFirstTime = true;
      this.setPrescriptionState(PrescriptionValidation.INVALID.key);
      return;
    }

    if (this.isProntoParaValidar()) {
      this.agendarValidacao();
    }
  }

  timeoutValidacao = null;
  private agendarValidacao() {
    if (this.timeoutValidacao) {
      clearTimeout(this.timeoutValidacao);
    }
    this.timeoutValidacao = setTimeout(() => { 
      let itemModel = Object.assign( new PrescriptionModel(), this.item);
      if ((this.item instanceof PrescriptionTemplateModel) || (itemModel && itemModel.paciente && itemModel.paciente.id && itemModel.dataPrescricao.length)) {
        this.validate$.next('validate');
      }
    }, 300);
  }

  private isProdutosProntos(): boolean {    
    return !this.idsProdWaiting || this.idsProdWaiting.length == 0;
  }

  private isProntoParaValidar(): boolean {    
    return this.isProdutosProntos();
  }

  private subscribeValidate() {
    this.validate$
      .pipe(
        skipWhile((val) => {
          return val === 'initialize';
        }),
        debounce(() => timer(500)),
        tap(() => {
          this.validationMessages = [];
          this.setPrescriptionState(PrescriptionValidation.LOADING.key);
          this.validationMessagesLoading = true;
          this.validationMessagesFirstTime = false;
          this.validationMessagesError = false;
        }),
        switchMap((data) => {
          let observableValidar: Observable<any> = null;
          
          if (this.item instanceof PrescriptionModel) {
            let item = this.item as PrescriptionModel;
            if (this.item.idPrescricao) {
              observableValidar = service.getValidationPrescriptionV2(Number(item.idPrescricao));
            } else {
              let payloadV2 = new PrescricaoParmDTO();
              payloadV2.load(item);
              if (!payloadV2.idPaciente || !payloadV2.datasPrescricao.length) {
                observableValidar = of(null);
              } else {
                payloadV2.idsPrescrAlter = this.idsAlter;
                observableValidar = service.validatePrescriptionV2(payloadV2);
              }   
            }
          } else if (this.item instanceof PrescriptionTemplateModel) {
            let item = this.item as PrescriptionTemplateModel;
            let payloadV2 = new TemplateValidacaoParmDTO();
            payloadV2.load(item);
            if (payloadV2.tipoPaciente == null || !payloadV2.volumeBolsaMl) {
              return;
            }
            observableValidar = validatePrescriptionTemplate(payloadV2);
          } else {
            const payload = {
              ...this.item.toJson(),
              produtos: this.flatProducts(this.groupList, true),
            };
            observableValidar = service.validatePrescription(payload);
          }

          return observableValidar.pipe(          
            catchError((err) => {
              this.validationMessagesLoading = false;
              this.validationMessagesError = true;
              this.showToastApiError(err);
              return of(false);
            }),
          );
        }),
      )
      .subscribe((result) => {
        if (!!result) {
          this.validationMessagesLoading = false;
          this.validationMessagesError = false;
          this.validationMessages = result || [];
          const prescriptionState = this.validatePrescriptionFormStatus(
            this.validationMessages,
          );
          this.setPrescriptionState(prescriptionState);
        } else {
          this.validationMessagesLoading = false;
          this.validationMessagesFirstTime = true;
          this.setPrescriptionState(PrescriptionValidation.INVALID.key);
        }
      });
  }

  private validatePrescriptionFormStatus(validationMessages: any[]): any {
    this.$refs.form.validate();
    if (!!validationMessages.length) {
      const hasError = validationMessages.some(
        (item) => item.acao === PrescriptionValidation.IMPEDITIVE.key,
      );
      return hasError
        ? PrescriptionValidation.IMPEDITIVE.key
        : PrescriptionValidation.ALERT.key;
    } else if (!this.form.valid) {
      return PrescriptionValidation.INVALID.key;
    } else {
      return PrescriptionValidation.OK.key;
    }
  }

  private setPrescriptionState(state: string): void {
    this.oldPrescriptionState = this.prescriptionState;
    this.prescriptionState = state;
  }

  public onProductWaiting(id: number) {
    this.idsProdWaiting.push(id);
  }

  public onProductDone(id: number) {
    this.idsProdWaiting.splice(this.idsProdWaiting.indexOf(id), 1);    
  }
}
